import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

export const shouldSubmitComposerKeyDown = (
  event: Pick<ReactKeyboardEvent<HTMLTextAreaElement>, 'key' | 'shiftKey' | 'repeat' | 'nativeEvent'>,
): boolean => {
  if (event.key !== 'Enter' || event.shiftKey || event.repeat) {
    return false;
  }

  const nativeEvent = event.nativeEvent;
  if (nativeEvent.isComposing || nativeEvent.keyCode === 229) {
    return false;
  }

  return true;
};
